<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center">
        <v-col>
            <loading-overlay :loading="loading"></loading-overlay>
            <v-row class="py-4" align="center" justify="center" no-gutters>
                <v-col class="form">
                    <v-card class="elevation-12" >
                        <v-toolbar
                            color="primary"
                            dark
                            flat
                        >
                            <v-toolbar-title>Your Recipients</v-toolbar-title>
                        </v-toolbar>
                        <template v-if="hasRecipients">
                            <v-simple-table height="300" fixed-header>
                                <thead>
                                    <tr>
                                        <th class="text-left">Name</th>
                                        <th v-if="!$store.state.user.can_post_offers" class="text-left">Recipient Type</th>
                                        <th v-if="!$store.state.user.can_post_offers" class="text-left">Payment Facilitator</th>
                                        <th v-if="!$store.state.user.can_post_offers" class="text-left">Account / Phone</th>
                                        <th v-if="$store.state.user.can_post_offers" class="text-left">Kaoshi Handle</th>
                                        <th colspan="2" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="recipient in recipients"
                                        :key="recipient.id"
                                        @click.prevent="openRecipientForm(recipient)"
                                        class="py-4"
                                    >
                                        <template v-if="!$store.state.user.can_post_offers">
                                            <!-- NAME -->
                                            <td v-if="recipient.recipient_info.account_name" class="text-uppercase">
                                                {{ recipient.recipient_info.account_name }}
                                            </td>
                                            <td v-else class="text-uppercase">
                                                {{ recipient.recipient_info.name }}
                                            </td>

                                            <!-- RECIPIENT TYPE -->
                                            <td class="text-capitalize">{{ recipient.recipient_type | formatPaymentTypeName }}</td>

                                            <!-- PAYMENT FACILITATOR -->
                                            <td v-if="recipient.institution_name">{{ recipient.institution_name }}</td>
                                            <td v-else class="text-center">-</td>

                                            <!-- ACCOUNT NUMBER / PHONE NUMBER -->
                                            <td v-if="recipient.recipient_type === 'bank-transfer'">
                                                <v-icon
                                                    class="mr-2"
                                                    left
                                                    small
                                                >
                                                    mdi-bank-outline
                                                </v-icon>
                                                {{ recipient.recipient_info.account_number }}
                                            </td>
                                            <td v-else-if="recipient.recipient_type === 'mobile-money'">
                                                <v-icon
                                                    class="mr-2"
                                                    left
                                                    small
                                                >
                                                    mdi-phone-outline
                                                </v-icon>
                                                {{ recipient.recipient_info.phone }}
                                            </td>
                                            <td class="text-center" v-else>-</td>

                                            <!-- EDIT BUTTON -->
                                            <td>
                                                <v-icon>mdi-account-edit-outline</v-icon>
                                            </td>

                                            <td>
                                                <v-btn icon
                                                    @click.stop="deleteRecipient(recipient)">
                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                </v-btn>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <!-- NAME -->
                                            <td>
                                                {{ recipient.recipient_info.name }}
                                            </td>

                                            <!-- Kaoshi Handle -->
                                            <td>{{ recipient.recipient_info.email }}</td>

                                            <!-- EDIT BUTTON -->
                                            <td>
                                                <!-- <v-icon>mdi-account-edit-outline</v-icon> -->
                                            </td>

                                            <td>
                                                <v-btn icon
                                                    @click.stop="deleteRecipient(recipient)">
                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                </v-btn>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </template>
                        <v-card-actions class="py-8">
                            <v-spacer />
                            <v-btn
                                x-large
                                color="primary"
                                dark
                                depressed
                                class="px-6"
                                @click.prevent="openRecipientForm()"
                                prepend-icon="mdi-plus"
                            >
                                New Recipient
                                <v-icon
                                    class="ml-2"
                                    right
                                    dark
                                >
                                    mdi-account-plus-outline
                                </v-icon>
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        </v-row>
    </v-container>
</template>

<script>
    /* eslint-disable camelcase */
    export default {
        filters: getFilters(),
        data,
        computed: getComputed(),
        mounted,
        methods: getMethods(),
    };

    function mounted() {
        const vm = this;
        setupUiElements();
        getRecipients();

        function getRecipients() {
            vm.loading = true;
            Vue.backendApi().user(vm.$store.state.user.id).recipient().listRecipients().then(success, error);

            function success(response) {
                Vue.set(vm, 'recipients', response.data);
                vm.loading = false;
            }

            function error(err) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error loading recipients',
                    text: err,
                });
            }
        }

        function setupUiElements() {
            vm.$store.commit('pageHeaderClass', 'rateAlert recipientList');
            vm.$store.commit('pageHeaderTitle', 'Recipient List');
            vm.$store.commit('mobileMenuIsVisible', true);
            vm.$store.commit('closeButtonIsVisible', false);
            vm.$store.commit('hideLogoPart', false);
        }
    }

    function data() {
        return {
            recipients: [],
            loading: false,
        };
    }

    function getComputed() {
        return {
            hasRecipients,
        };

        function hasRecipients() {
            return this.recipients.length > 0;
        }
    }

    function getMethods() {
        return {
            openRecipientForm,
            deleteRecipient,
        }

        function openRecipientForm(recipient) {
            const vm = this;
            if (vm.$_userCanPostOffers === 1 && !recipient) {
                vm.$router.push({name: 'recipient-edit-poster', params: { recipient: recipient }});
            } else {
                vm.$router.push({name: 'recipient-edit', params: { recipient: recipient }});
            }
        }

        async function deleteRecipient(recipient) {
            const vm = this;
            this.$swal.fire({
                title: 'Are you sure?',
                text: `You won't be able to revert this!`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
            }).then((result) => {
                if (result.value) {
                    deleteThisRecipient();
                }
            });

            async function deleteThisRecipient() {
                try {
                    vm.loading = true
                    const recipientId = recipient.id
                    const recipients = vm.recipients.filter(item => item.id !== recipientId)
                    await Vue.backendApi()
                                .user(vm.$store.state.user.id)
                                .recipient(recipientId)
                                .deleteRecipient()
                    vm.recipients = recipients;
                    vm.$swal.fire(
                        'Deleted!',
                        'This recipient has been deleted.',
                        'success'
                    )
                } catch (error) {
                    vm.$swal({
                        type: 'error',
                        title: 'Error deleting recipient',
                        text: error,
                    })
                } finally {
                    vm.loading = false
                }
            }
        }
    }

    function getFilters() {
        return {
            formatPaymentTypeName,
        };

        function formatPaymentTypeName(paymentType) {
            const paymentTypes = {
                paypal_payment: 'Paypal',
                sepa_payment: 'Sepa',
                interac_payment: 'Interac',
                zelle_payment: 'Zelle',
                faster_payment: 'Faster',
                nigerian_bank_payment: 'Nigerian Bank',
                ghana_bank_payment: 'Ghanian Bank',
                airtel_bank_payment: 'Mobile Money',
            };
            if (paymentTypes[paymentType.toLowerCase()]) {
                return paymentTypes[paymentType.toLowerCase()];
            }
            return paymentType.replace(/-/g, ' ');
        }
    }
</script>

<style scoped>
.form {
    max-width: 900px;
}
tbody {
    background-color: #F5F5F5;
}
</style>
